import {
  Content,
  ContentAnnotation,
  ContentComplement,
  ContentDoubt, Question, QuestionStatus, ScormCheckpoint
} from "../../../infrastructure/presentation/views/content/helpers";
import {CourseContentProvider} from "./course-content-provider";
import {InterfaceCourseUseCases} from "../../usecase/impl/courseUseCases";
import {EventContentProvider} from "./event-content-provider";
import {Rating, RatingList} from "../rating";
import courseContentUseCase from "../../usecase/content_provider/course/content_repository";
import eventContentUseCase from "../../usecase/content_provider/event/content_repository";
import {Instructor} from "../entities";

export enum ContentProviderType {
  COURSE,
  EVENT,
}

export interface ContentProvider {
  // Return type of this content_provider provider
  getType(): ContentProviderType;

  // Return id of this content_provider provider
  getID(): number;


  getAllContents(): Promise<Content[]>;

  initializeContent(contentID): Promise<void>;

  getContentByID(contentID: number): Promise<Content>;

  finishContentProvider(): Promise<void>;

  getAllContents(): Promise<Content[]>;

  getContentByID(contentID: number): Promise<Content>;

  getAllComplements(id: number): Promise<ContentComplement[]>;

  createRating(contentID: number, rating: Rating): Promise<Rating>;

  getAllRatings(contentID: number, index?: number): Promise<RatingList>;

  likeRating(ratingID: number): Promise<void>;

  removeLikeRating(ratingID: number): Promise<void>;
  deleteRating(ratingID: number,contentID: number): Promise<void>

  createDoubt(contentID: number, contentDoubt: ContentDoubt): Promise<ContentDoubt>;

  getAllDoubts(contentID: number): Promise<ContentDoubt[]>;

  getContentInstructors(contentID: number): Promise<Instructor[]>;

  createContentAnnotation(contentID: number, annotation: ContentAnnotation): Promise<ContentAnnotation>;

  getAllContentAnnotations(contentID: number): Promise<ContentAnnotation[]>;

  updateContentAnnotation(contentID: number, annotation: ContentAnnotation): Promise<ContentAnnotation>;

  deleteContentAnnotation(contentID: number, annotationID: number): Promise<void>;

  saveCheckpointSeconds(contentID: number, timestamp: number): Promise<void>;

  saveCheckpointSCORM(contentID: number, scormCheckpoint: ScormCheckpoint): Promise<void>;

  saveProgress(contentID: number, speedRate: number): Promise<number>;

  generateQuestionnaire(contentID: number): Promise<number>;

  getQuestionByPage(contentID: number, questionnaireID: number, page: number): Promise<Question>;

  replyQuestionByPage(contentID: number, questionnaireID: number, page: number, alternativeID: number): Promise<QuestionStatus>;

  finishContent(contentID: number): Promise<void>;

  replyDescriptiveQuestionByPage(contentID: number, questionnaireID: number, page: number, answer: string): Promise<QuestionStatus>;
}

type ContentProviderIDs = {
  providerID: number,
  classID: number,
}

class ContentProviderBuilder {
  build(type: ContentProviderType, ids: ContentProviderIDs): ContentProvider {
    switch (type) {
      case ContentProviderType.COURSE:
        return new CourseContentProvider(
          ids.providerID,
          InterfaceCourseUseCases,
          courseContentUseCase
        );

      case ContentProviderType.EVENT:
        return new EventContentProvider(ids.providerID, ids.classID, eventContentUseCase);
    }
  }
}

export const contentProviderBuilder = new ContentProviderBuilder();
